import { LightGQL } from '@shared/api/gql-service/LightGQLService'
import { MAPPING_API_GQL } from '@shared/api/middleware/mappingAPI'
import { GQL_TAGS } from '@shared/api/api.gql'
import type { TypeMappingDailyGQLOutput } from '@shared/api/middleware/mappingAPI/gql_daily/type'

import {
  isHealthyDailyArticlesList,
  pickValidDailyArticles,
} from '@shared/api/middleware/mappingAPI/gql_daily/helpers/isValidDailyArticle'

let cachedArticles: TypeMappingDailyGQLOutput[] | undefined

export const readDailyArticlesCache = (): TypeMappingDailyGQLOutput[] | undefined => {
  return isHealthyDailyArticlesList(cachedArticles) ? cachedArticles : undefined
}

export const writeDailyArticlesCache = (list: TypeMappingDailyGQLOutput[]): void => {
  const validList = pickValidDailyArticles(list)

  if (isHealthyDailyArticlesList(validList)) {
    cachedArticles = validList
  }
}

const fetchDailyArticles = () =>
  LightGQL.daily.query(GQL_TAGS.DAILY, {
    mapping: MAPPING_API_GQL.daily,
    skipPersistedQuery: true,
    requestInit: { cache: 'no-store' },
  })

export const revalidateDailyArticles = async (): Promise<TypeMappingDailyGQLOutput[]> => {
  const list = pickValidDailyArticles(await fetchDailyArticles())

  writeDailyArticlesCache(list)

  return list
}
